import {useIntellsysConfiguration} from "~/contexts/intellsysConfigurationContext";

type OttopilotConfigurationContextData = {
    intellsysBaseUrl: string;
    environment: string;
    websiteBaseUrl: string;
};

export function useOttopilotConfiguration(): OttopilotConfigurationContextData {
    const {intellsysBaseUrl} = useIntellsysConfiguration();

    return {
        intellsysBaseUrl,
        environment: "dev",
        websiteBaseUrl: intellsysBaseUrl,
    };
}
